import "./postsurveypage.css";

import React, { useState } from "react";

import Body from "../Navigation/Body";
import { Button } from "react-bootstrap";
import { PostSurveyQuestionnaire } from "./PostSurveyQuestionnaire";
import { ClosingScreen } from "./Closing";
import { useSelector } from "react-redux";

export default function PostSurveyPage() {
  const q_submitted = useSelector(
    (state) => state.user.postsurvey_form.submitted
  );

  return (
    <Body
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
      }}
    >
      {q_submitted ? (
        // <ClosingScreen />
        <PostSurveyQuestionnaire />
      ) : (
        <>
          <PostSurveyQuestionnaire />
        </>
      )}
    </Body>
  );
}
